<template>
  <common-dialog ref="dialog" width="500px" title="绑定新店铺" id-key="id" @closed="onClosed">
    <template slot="form">
      <div style="display: flex;align-items: center;">
        <div>第一步：点击</div>
        <div style="margin-left: 5px;">
          <el-button type="success" @click="onCopy">前往店铺官方授权页面</el-button>
        </div>
      </div>
      <div style="margin-top: 10px;margin-bottom: 10px;">
        <div>第二步：由该店铺登录后，复制要绑定的店铺代码，粘贴到下方输入框。</div>
      </div>
      <el-input v-model="key" placeholder="请输入店铺代码"></el-input>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="onBind">绑 定</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import dialogMixin from '@/mixins/dialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [dialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require('@/api/pdd/mall').default,
      key: ''
    };
  },
  methods: {
    onCopy() {
      window.open(this.$store.state.settings.bindLink);
      // navigator.clipboard.writeText(this.$store.state.settings.bindLink).then(() => {
      //   this.$message.success('复制成功');
      // }).catch(err => {
      //   console.log('复制失败', err);
      //   this.$message.error('复制失败');
      // });
    },
    onBind() {
      this.api.connect(this.key).then(res => {
        if (res) {
          // var mall_list = this.$store.state.user.mallList;
          // mall_list.push({
          //   logo: res.logoUrl,
          //   mallId: res.mallId,
          //   mallName: res.mallName,
          //   mainType: res.mainType,
          //   expirationDate: this.$commonJs.toDateString(res.expirationDate),
          //   day: this.$commonJs.getIntervalDays(res.expirationDate, new Date()),
          // });

          // localStorage.setItem("mall_list", JSON.stringify(mall_list));
          // this.$store.dispatch("setMallList");

          this.$emit('close-saved');
          this.close(true);
        }
      })
    },
    onClosed() {
      this.key = "";
    }
  },
};
</script>
